var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wallet-status-button nq-button-pill",on:{"click":function($event){return _vm.$router.push('/wallet-status')}}},[_c('CircledQuestionMark'),_c('span',[_vm._v(_vm._s(_vm.$t('Help')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }